export interface VerifyCentential {
  provider_access_token: string;
  hospital_code: string;
  type: string;
  digital_signature_image_code: string;
  json_description: JsonDescription;
}

export interface StaffVerifyCentential {
  provider_access_token: string;
  hospital_code: string;
  type: string;
  json_description: StaffJsonDescription;
}

export interface JsonDescription {
  visit_date: string; // format: YYYY-MM-DD
  creator: Creator;
  patient: Patient;
  findings: string;
  diagnosis: string;
  recommendation: string;
}

export interface StaffJsonDescription {
  visit_date: string; // format: YYYY-MM-DD
  creator: Creator;
  patient: Patient;
  findings: string;
  diagnosis: string;
  recommendation: string;
}

export interface Creator {
  account_id: string;
  prefix: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  license_no: string; // 11 digit
  department: string; // example: 001, 002
}

export interface Patient {
  profile: PatientProfile;
  address: PatientAddress;
}

export interface PatientProfile {
  hn: string; // start with HN-XXXX
  cid: string; // 13 digit
  passport_no: string;
  prefix: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  gender: string; // example: 001, 002
  birthdate: string; // format: YYYY-MM-DD
  age: string;
  weight: string;
  height: string;
  blood_pressure: string; // example: 120/80
  pulse: string; // example: 65
}

export interface PatientAddress {
  no: string; // house number or building number
  village_no: string; // village number
  alley: string;
  street: string;
  province: string;
  district: string;
  subdistrict: string;
  zip_code: string;
  email: string;
  phone: string; // 10 digit
  remark: string; // optional - empty string for default
}

// * Other Data

export interface Province {
  province_thai_name: string;
  province_english_name: string;
  province_code: string;
}

export interface District {
  district_thai_name: string;
  district_english_name: string;
  district_code: string;
}

export interface Tambol {
  tambon_code: string;
  tambon_thai_name: string;
  tambon_english_name: string;
  zip_code: string;
  country_code: string;
  region_code: string;
}

export interface Gender {
  gender_no: number;
  gender_code: string;
  gender_name_th: string;
  gender_name_eng: string;
  created_by: string;
  updated_by: string;
  is_active: boolean;
  is_delete: boolean;
}

export interface Prefix {
  prefix_no: number;
  prefix_code: string;
  prefix_name_th: string;
  prefix_abbr_th: string;
  prefix_abbr_eng: string;
  subfix_abbr_eng: string;
  created_by: string;
  updated_by: string;
  is_active: boolean;
  is_delete: boolean;
}

export interface PrefixPatient {
  prefix_code: string
  prefix_name_th: string
}

// create an function for initial default value
// export function getDefaultVerifyCentential(): VerifyCentential {
//   const imageCode = sessionStorage.getItem("digital_signature_image_code") || ""; // ตรวจสอบการดึงข้อมูลจาก localStorage ว่าค่ามีอยู่หรือไม่
//   const originalString = imageCode;
//   const resultImageCode = originalString.replace(/"/g, ""); // ลบเครื่องหมายคำพูดทั้งหมด

//   const hcode = sessionStorage.getItem("hcode") || ""; // ตรวจสอบการดึงข้อมูลจาก localStorage ว่าค่ามีอยู่หรือไม่
//   const originalStringHcode = hcode;
//   const hCodeData = originalStringHcode.replace(/"/g, "");
//   return {
//     provider_access_token: "", // กำหนดค่าเริ่มต้นเป็นสายอักขระว่าง
//     hospital_code: hCodeData, // ใช้ hcode จาก localStorage
//     type: "", // กำหนดค่าเริ่มต้น
//     digital_signature_image_code: resultImageCode, // ใช้ค่า imageCode จาก localStorage
//     json_description: {
//       visit_date: "", // กำหนดค่าเริ่มต้นเป็นสายอักขระว่าง
//       creator: {
//         account_id: "", // กำหนดค่าเริ่มต้น
//         prefix: "", // กำหนดค่าเริ่มต้น
//         first_name: "", // กำหนดค่าเริ่มต้น
//         last_name: "", // กำหนดค่าเริ่มต้น
//         middle_name: "", // กำหนดค่าเริ่มต้น
//         license_no: "", // กำหนดค่าเริ่มต้น
//         department: "", // กำหนดค่าเริ่มต้น
//       },
//       patient: {
//         profile: InitialPatientProfile(), // เรียกใช้ฟังก์ชันสำหรับค่าเริ่มต้นของ profile ผู้ป่วย
//         address: InitialPatientAddress(), // เรียกใช้ฟังก์ชันสำหรับค่าเริ่มต้นของที่อยู่ผู้ป่วย
//       },
//       findings: "", // กำหนดค่าเริ่มต้น
//       diagnosis: "", // กำหนดค่าเริ่มต้น
//       recommendation: "", // กำหนดค่าเริ่มต้น
//     },
//   };
// }

export function InitialPatientProfile(): PatientProfile {
  return {
    hn: "",
    cid: "",
    passport_no: "",
    prefix: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    gender: "",
    birthdate: "",
    age: "",
    weight: "",
    height: "",
    blood_pressure: "",
    pulse: "",
  };
}

export function InitialPatientAddress(): PatientAddress {
  return {
    no: "",
    village_no: "",
    alley: "",
    street: "",
    province: "",
    district: "",
    subdistrict: "",
    zip_code: "",
    email: "",
    phone: "",
    remark: "",
  };
}

// make function for assign default value for field hospital_code and digital_signature_image_code
// export function getInitialVC(): VerifyCentential {
//   const imageCode = sessionStorage.getItem("digital_signature_image_code") || ""; // ตรวจสอบการดึงข้อมูลจาก localStorage ว่าค่ามีอยู่หรือไม่
//   const originalString = imageCode;
//   const resultImageCode = originalString.replace(/"/g, ""); // ลบเครื่องหมายคำพูดทั้งหมด
//   const hcode = sessionStorage.getItem("hcode") || ""; // ตรวจสอบการดึงข้อมูลจาก localStorage ว่าค่ามีอยู่หรือไม่
//   const originalStringHcode = hcode;
//   const hCodeData = originalStringHcode.replace(/"/g, "");
//   const defaultValues = getDefaultVerifyCentential();
//   defaultValues.hospital_code = hCodeData;
//   defaultValues.digital_signature_image_code = resultImageCode;
//   return defaultValues;
// }
